import { atom } from "jotai";

export interface IChatMessageWindowStore {
  open: boolean;
  disabled: boolean;
}

const initialState: IChatMessageWindowStore = {
  open: false,
  disabled: false,
};

export const ChatMessageWindowStore = atom<IChatMessageWindowStore>(initialState);
